import BaseComponent from '../lib/BaseComponent';
import Choices from 'choices.js';
import $ from '@vaersaagod/tools/Dom';
import request from '@vaersaagod/tools/request';

export class IngredientsComponent extends BaseComponent {

    init() {
        const self = this;

        this.isPopping = false;
        this.url = $(this.el).data('url');
        this.results = $('[data-recipies-results]');
        this.breadcrumbs = $('[data-breadcrumb-items]');
        this.breadcrumb = $('.breadcrumb');

        this.choices = new Choices($(this.el).find('#ingredients').get(0), {
          loadingText: 'Laster...',
          noResultsText: 'Ingen treff',
          itemSelectText: 'Klikk for å velge',
          removeItemButton: true,
          searchResultLimit: 10,
          searchFields: ['customProperties.keys'],
          choices: $(this.el).data('ingredients'),
          fuseOptions: {
            shouldSort: true,
            findAllMatches: true,
            threshold: 0.3,
            location: 0,
            distance: 300
          }
        });

        this.choices.passedElement.addEventListener('addItem', this.onUpdate.bind(this), false);
        this.choices.passedElement.addEventListener('removeItem', this.onUpdate.bind(this), false);

        this.helpers = $(this.el).find('[data-helper]');
        this.helpers.on('click', function(e){
          e.preventDefault();
          self.choices.setValueByChoice($(e.target).data('id'));
        });

        window.addEventListener('popstate', this.onPopstate.bind(this), false);
    }

    onPopstate(e) {
      console.log(e);
      this.isPopping = true;
      this.choices.removeActiveItems();
      if (e.state && e.state.values) {
        this.choices.setValueByChoice(e.state.values.map( item => item.value ));
        this.updateBreadcrumb(document.location.href, e.state.values);
      } else {
        this.removeBreadcrumb();
      }
      this.loadUrl(document.location.href);
    }

    onUpdate() {
      if (!this.isPopping) {
        const values = this.choices.getValue();
        const partials = values.map( item => {
          return values.length > 1 ? item.customProperties.slug : item.customProperties.url;
        });

        let url = values.length ? this.url + '/' + partials.join('-') : this.url;
        url = values.length === 1 ? partials[0] : url;

        history.pushState({values: values}, '', url);

        this.choices.hideDropdown();
        if (values.length) {
          this.updateBreadcrumb(url, values);
        } else {
          this.removeBreadcrumb();
        }

        this.loadUrl(url);
      }
    }

    removeBreadcrumb() {
      this.breadcrumbs.find('[data-recipe-breadcrumb]').parent().remove();
    }

    updateBreadcrumb(url, values) {
      let breadcrumb = this.breadcrumbs.find('[data-recipe-breadcrumb]');
      if (!breadcrumb.length) {
        this.breadcrumbs.append('<li class="breadcrumb__item"><a href="#" class="breadcrumb__item-link" data-recipe-breadcrumb></a></li>');
        breadcrumb = this.breadcrumbs.find('[data-recipe-breadcrumb]');
      }
      if(url && values) {
        breadcrumb.attr('href', url);
        breadcrumb.html( values.map( item => item.label ).join(', ') );
      }
    }

    loadUrl(url) {
      TweenLite.to(this.results.find('.recipies__item, [data-no-hits]').nodes, 0.2, {opacity: 0, ease:'Sine.easeIn'});
      request.get(url).then(res => {
          const response = $(res.text).find('[data-recipies-results]');
          this.results.html( response.html() );
          this.isPopping = false;
      }, error => {
          console.error(error);
      });
    }

    destroy() {
      this.choices.destroy();
      window.addEventListener('popstate', this.onPopstate.bind(this));
    }

}

export default IngredientsComponent;



// WEBPACK FOOTER //
// ./src/js/components/Ingredients.js